/**
 *
 * Asynchronously loads the component for StepBackPromptModal
 *
 */

import { lazyLoad } from 'utils/loadable';

export const StepBackPromptModal = lazyLoad(
  () => import('./index'),
  module => module.StepBackPromptModal,
);
